export const PLACE_HOLDER_WITH_AI =
  'Share your feedback here. You can also write an outline using bullet points and use our "Help me write" AI feature to improve the quality of your feedback. Our AI features only work on English text.';

export const PLACE_HOLDER_WITHOUT_AI = 'Please provide a basis for your assessment. If possible, with an example ';
